import { render, staticRenderFns } from "./PaymentTypes.vue?vue&type=template&id=6961d3f5&scoped=true"
import script from "./PaymentTypes.vue?vue&type=script&lang=js"
export * from "./PaymentTypes.vue?vue&type=script&lang=js"
import style0 from "./PaymentTypes.vue?vue&type=style&index=0&id=6961d3f5&prod&scoped=true&lang=css"
import style2 from "./PaymentTypes.vue?vue&type=style&index=2&id=6961d3f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961d3f5",
  null
  
)

export default component.exports